module.exports = __webpack_public_path__ + "static/media/earhear-3.d49e0acc.png";